import { MgSupplierItemSearchResultDTO } from '../../dto';
import { DiscountGroup } from '../DiscountGroup';
import { ProductGroup } from '../finfo';
import { Discontinuation } from './MgItemDiscontinuation';
import { SupplierItemAssortmentTag } from './SupplierItemAssortmentTag';

interface ConstructorProps {
  id: number;
  finfoNumber?: number;
  nobbNumber?: number;
  mgSupplierItemId: number;
  supplierItemId?: string;
  mgSupplierId: number;
  mgParticipantAccountName: string;
  participantAccountName: string;
  mgItemNumber: number;
  bk04Varegruppe?: ProductGroup;
  groupNumber: string;
  primaryText: string;
  gtinCode?: string;
  finfoSupplierId?: number;
  secondaryText?: string;
  mainSupplier: boolean;
  mainSupplierName?: string;
  inAssortment: boolean;
  discountGroup?: DiscountGroup;
  discontinuation: Discontinuation;
  tags: SupplierItemAssortmentTag[];
}

export class MgSupplierItemSearchResult {
  id: number;
  finfoNumber?: number;
  nobbNumber?: number;
  mgSupplierItemId: number;
  supplierItemId?: string;
  mgSupplierId: number;
  mgParticipantAccountName: string;
  participantAccountName: string;
  mgItemNumber: number;
  bk04Varegruppe?: ProductGroup;
  groupNumber: string;
  primaryText: string;
  gtinCode?: string;
  finfoSupplierId?: number;
  secondaryText?: string;
  mainSupplier: boolean;
  mainSupplierName?: string;
  inAssortment: boolean;
  discountGroup?: DiscountGroup;
  discontinuation: Discontinuation;
  tags: SupplierItemAssortmentTag[];

  constructor({
    id,
    finfoNumber,
    nobbNumber,
    mgSupplierItemId,
    supplierItemId,
    mgSupplierId,
    mgParticipantAccountName,
    participantAccountName,
    mgItemNumber,
    bk04Varegruppe,
    groupNumber,
    primaryText,
    gtinCode,
    finfoSupplierId,
    secondaryText,
    mainSupplier,
    mainSupplierName,
    inAssortment,
    discountGroup,
    discontinuation,
    tags,
  }: ConstructorProps) {
    this.id = id;
    this.finfoNumber = finfoNumber;
    this.nobbNumber = nobbNumber;
    this.mgSupplierItemId = mgSupplierItemId;
    this.supplierItemId = supplierItemId;
    this.mgSupplierId = mgSupplierId;
    this.mgParticipantAccountName = mgParticipantAccountName;
    this.participantAccountName = participantAccountName;
    this.mgItemNumber = mgItemNumber;
    this.bk04Varegruppe = bk04Varegruppe;
    this.groupNumber = groupNumber;
    this.primaryText = primaryText;
    this.gtinCode = gtinCode;
    this.finfoSupplierId = finfoSupplierId;
    this.secondaryText = secondaryText;
    this.mainSupplier = mainSupplier;
    this.mainSupplierName = mainSupplierName;
    this.inAssortment = inAssortment;
    this.discountGroup = discountGroup;
    this.discontinuation = discontinuation;
    this.tags = tags;
  }

  static fromSearchResultDTOs = (
    searchResultDtos: MgSupplierItemSearchResultDTO[],
    bk04Varegrupper: ProductGroup[]
  ): MgSupplierItemSearchResult[] =>
    searchResultDtos.map(
      (dto) =>
        new MgSupplierItemSearchResult({
          id: dto.id,
          finfoNumber: dto.finfoNumber,
          nobbNumber: dto.nobbNumber,
          mgSupplierItemId: dto.mgSupplierItemId,
          supplierItemId: dto.supplierItemId,
          mgSupplierId: dto.mgSupplierId,
          mgParticipantAccountName: dto.mgParticipantAccountName,
          participantAccountName: dto.participantAccountName,
          mgItemNumber: dto.mgItemNumber,
          bk04Varegruppe: bk04Varegrupper.find(
            ({ groupNumber }) => dto.bk04ProductGroup === groupNumber
          ),
          groupNumber: dto.bk04ProductGroup,
          primaryText: dto.primaryText,
          gtinCode: dto.gtinCode,
          finfoSupplierId: dto.finfoSupplierId,
          secondaryText: dto.secondaryText,
          mainSupplier: dto.mainSupplier,
          mainSupplierName: dto.mainSupplierName,
          inAssortment: dto.inAssortment,
          discountGroup: dto.discountGroup,
          discontinuation: dto.discontinuation,
          tags: dto.tags ? dto.tags.map(SupplierItemAssortmentTag.fromDto) : [],
        })
    );
}
